import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { dateFormatter } from '@/utils/formatTime';
import { ChatConversationApi } from '@/api/ai/chat/conversation';
import * as UserApi from '@/api/system/user';
import { onMounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ChatConversationList',
  setup(__props) {
    const message = useMessage(); // 消息弹窗
    // const { t } = useI18n() // 国际化
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      userId: undefined,
      title: undefined,
      createTime: []
    });
    const queryFormRef = ref(); // 搜索的表单
    const userList = ref([]); // 用户列表
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await ChatConversationApi.getChatConversationPage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await ChatConversationApi.deleteChatConversationByAdmin(id);
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 初始化 **/
    onMounted(async () => {
      getList();
      // 获得用户列表
      userList.value = await UserApi.getSimpleUserList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          class: "-mb-15px",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户编号",
            prop: "userId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.userId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.userId = $event),
              clearable: "",
              placeholder: "请输入用户编号",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "聊天编号",
            prop: "title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.title = $event),
              placeholder: "请输入聊天编号",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "创建时间",
            prop: "createTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: queryParams.createTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.createTime = $event),
              "value-format": "YYYY-MM-DD HH:mm:ss",
              type: "daterange",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "default-time": [new Date('1 00:00:00'), new Date('1 23:59:59')],
              class: "!w-240px"
            }, null, 8, ["modelValue", "default-time"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:search",
                class: "mr-5px"
              }), _cache[5] || (_cache[5] = _createTextVNode(" 搜索"))]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: resetQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:refresh",
                class: "mr-5px"
              }), _cache[6] || (_cache[6] = _createTextVNode(" 重置"))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "对话编号",
            align: "center",
            prop: "id",
            width: "180",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            label: "对话标题",
            align: "center",
            prop: "title",
            width: "180",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            label: "用户",
            align: "center",
            prop: "userId",
            width: "180"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(userList.value.find(item => item.id === scope.row.userId)?.nickname), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "角色",
            align: "center",
            prop: "roleName",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "模型标识",
            align: "center",
            prop: "model",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "消息数",
            align: "center",
            prop: "messageCount"
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            align: "center",
            prop: "createTime",
            formatter: _unref(dateFormatter),
            width: "180px"
          }, null, 8, ["formatter"]), _createVNode(_component_el_table_column, {
            label: "温度参数",
            align: "center",
            prop: "temperature"
          }), _createVNode(_component_el_table_column, {
            label: "回复 Token 数",
            align: "center",
            prop: "maxTokens",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            label: "上下文数量",
            align: "center",
            prop: "maxContexts",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            width: "180",
            fixed: "right"
          }, {
            default: _withCtx(scope => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:chat-conversation:delete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[3] || (_cache[3] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[4] || (_cache[4] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      })], 64);
    };
  }
});